import post from '../postService'
import URL from '../../Constants/apiUrls'

export default async function getAllAssetClass(reqData) {
  try {
    const res = await post(`${URL.getAllAssetClass}`, reqData)
    return res.data
  } catch (error) {
    return error
  }
}
